module.exports = __webpack_public_path__ + "static/media/skeleton-background.05c0fb60.svg";